import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import { mealItemEditModalStore } from '../../store/mealItemEditModalStore';
import integrationsStore from '~/mobx/integrationStore';
import { localeStore } from '~/mobx/localesStore';
import { formatPrice } from '~/utils/formatter';
import { isDisabledByPos } from '~/utils/helpers';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Input from '~/view/components/Controls/InputComponent/Input';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import Text from '~/view/components/Text/Text';

export const MealItemEditModalFormPriceBlock: FC = memo(
  observer((): ReactElement => {
    const { comboMealChangeDiscountPrice } = integrationsStore.posRestrictions || {};

    const _isDisabledByPos = useMemo((): boolean => isDisabledByPos(comboMealChangeDiscountPrice), [comboMealChangeDiscountPrice]);
    const headerDisabled = useMemo((): boolean => !mealItemEditModalStore.item || _isDisabledByPos, [mealItemEditModalStore.item, _isDisabledByPos]);
    const inputDisabled = useMemo((): boolean => !mealItemEditModalStore.item && !_isDisabledByPos, [mealItemEditModalStore.item, _isDisabledByPos]);

    const itemPrice = useMemo((): string | null => {
      if (!mealItemEditModalStore.item) return null;

      return localeStore.t('item_price') + ': ' + formatPrice(mealItemEditModalStore.item.product_price || 0);
    }, [mealItemEditModalStore.item]);

    return (
      <div className="d-flex flex-column">
        <Text type="block-header" text="discounted_price" className="mt-4" disabled={headerDisabled} required />

        <IntegrationManager
          setting={comboMealChangeDiscountPrice}
          wrapperClassName="mt-2 "
          tooltipOptions={{ position: TOOLTIP_POSITION.PORTAL }}
          withTooltip
        >
          <Input
            type="floatNumber"
            value={mealItemEditModalStore.item?.price}
            onChangeValue={mealItemEditModalStore.onChangePrice}
            disabled={inputDisabled}
            contentClassName="full-width"
          />
        </IntegrationManager>

        {itemPrice ? <Text type="block-header" text={itemPrice} className="mt-4" noTranslate /> : null}
      </div>
    );
  })
);
